import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
  consumeSuppressNextPostLoginPreserveForKey,
  setPostLoginRedirectFromLocation,
} from 'utils/postLoginRedirect';

/**
 * Unauthenticated user hit a non-auth URL; remember internal path for after login.
 */
export default function RedirectToLoginPreservingNext() {
  const location = useLocation();
  if (!consumeSuppressNextPostLoginPreserveForKey(location.key)) {
    setPostLoginRedirectFromLocation(
      location.pathname,
      location.search,
      location.hash,
    );
  }

  return <Navigate to="/" replace />;
}
